<template>
	<div class="wrapMonthWrap">
		<div class="wrapMonthDay">
			<div class="date">
				<svg-sprite icon-id="weekMon" width="20" height="20" />
				<div class="text">Monday</div>
			</div>
			<div class="date">
				<svg-sprite icon-id="weekTue" width="20" height="20" />
				<div class="text">Tuesday</div>
			</div>
			<div class="date">
				<svg-sprite icon-id="weekWed" width="20" height="20" />
				<div class="text">Wednesday</div>
			</div>
			<div class="date">
				<svg-sprite icon-id="weekThu" width="20" height="20" />
				<div class="text">Thursday</div>
			</div>
			<div class="date">
				<svg-sprite icon-id="weekFri" width="20" height="20" />
				<div class="text">Friday</div>
			</div>
			<div class="date weekend">
				<svg-sprite icon-id="weekSat" width="20" height="20" />
				<div class="text">Saturday</div>
			</div>
			<div class="date weekend">
				<svg-sprite icon-id="weekSun" width="20" height="20" />
				<div class="text">Sunday</div>
			</div>
			<month-day
					v-for="(item, index) in list"
					:key="index"
					:item="item"
					@updateEventIconBtn="onEventIconBtn($event, item)"
					:is-btn-sick="isBtnSick"
					:is-btn-work-time="isBtnWorkTime"
			/>
		</div>
	</div>
</template>

<script>
import MonthDay from "@/pages/Account/Tabs/MonthWrap/MonthDay.vue";

export default {
	name: "MonthWrap",
	components: { MonthDay },
	props: {
		list: Array,
		isBtnSick: {
			type: Boolean,
			default: false
		},
		isBtnWorkTime: {
			type: Boolean,
			default: false
		},
	},
	methods: {
		onEventIconBtn(key, item) {
			this.$emit('updateEventIconBtn', { key: key.key, item });
		},
	},
};
</script>

<style scoped lang="scss">
.head,
.wrapMonthDay {
	width: 100%;
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 4px;

	@media screen and (max-width: 1000px) {
		grid-template-columns: repeat(1, 1fr);
	}
	.monthDay.disabled {
		@media screen and (max-width: 1000px) {
			display: none;
		}
	}

	.date {
		padding: 4px;
		background: rgba(0, 0, 0, 0.14);
		display: flex;
		align-items: center;
		gap: 4px;
		color: var(--card-color);
		font-size: 14px;
		@media screen and (max-width: 1000px) {
			display: none;
		}
		svg {
			color: var(--base-green);
		}
		&.weekend {
			svg {
				color: var(--base-red-dark);
			}
		}
	}
}

</style>
